var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"catalogues__button",on:{"click":function($event){return _vm.$emit('showModal')}}},[_vm._v(" Crear Catálogos ")])
}
var staticRenderFns = []

export { render, staticRenderFns }